import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { CompanySuggestion } from '@savgroup-front-common/types/CompanyDirectory';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

export const COMPANY_SEARCH_MINIMUM_QUERY_LENGTH = 3;

export interface SearchCompaniesQueryArgs {
  query: string;
  countryCode?: string;
  limit?: number;
  signal?: AbortSignal;
}

export const searchCompaniesRequest = ({
  query,
  countryCode,
  limit,
  signal,
}: SearchCompaniesQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(`${APIConfiguration.seller}companies/search`, {
    query,
    countryCode,
    limit,
  }),
  config: { method: SUPPORTED_METHODS.GET, signal },
});

export async function searchCompaniesQuery({
  query,
  countryCode,
  limit,
  signal,
}: SearchCompaniesQueryArgs): Promise<
  BackResponseFailure | BackResponse<CompanySuggestion[]>
> {
  try {
    return await executeQuery<BackResponse<CompanySuggestion[]>>(
      searchCompaniesRequest({ query, countryCode, limit, signal }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
